import {useState, useMemo} from 'react';
import type {GlCateDetailRow} from '@/components/account/gl-invoice/mode/GlCateDetail';

/**
 * WP 弹�???GL Invoice Detail Dialog ?�思管??hook
 * �?currentData?.glInvoiceDetails 中�??��??�杮，管??dialog 开?�状?? */
export function useWpGlInvoiceDetail(currentData: any) {
    const [open, setOpen] = useState(false);

    const rows: GlCateDetailRow[] = useMemo(() => {
        const raw = currentData?.glInvoiceDetails;
        if (!Array.isArray(raw) || raw.length === 0) return [];
        return raw.map((item: any) => ({
            invoiceId: item.invoiceId,
            date: item.date,
            description: item.description,
            voucherNo: item.voucherNo,
            invoiceNo: item.invoiceNo,
            invoiceDate: item.invoiceDate,
            chequeNo: item.chequeNo,
            details: item.details,
            amount: Number(item.amount) || 0,
            counterparts: item.counterparts,
        }));
    }, [currentData?.glInvoiceDetails]);

    const total = useMemo(
        () => rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0),
        [rows],
    );

    return {open, setOpen, rows, total};
}
